var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 12,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#quick_svg__clip0_9804_9671)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "quick_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 0H0v12h41V0z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#quick_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.93 9.708c0 .424-.127.838-.365 1.19a2.172 2.172 0 01-3.321.325 2.14 2.14 0 01-.468-2.336c.164-.392.44-.727.795-.962a2.169 2.169 0 012.726.266c.405.402.632.948.632 1.517zM17.28 3.14h2.65v3.685a3.936 3.936 0 01-1.165 2.793 3.99 3.99 0 01-2.81 1.156 3.989 3.989 0 01-2.812-1.156 3.936 3.936 0 01-1.164-2.793V3.14h2.65v3.685a1.31 1.31 0 00.388.931 1.327 1.327 0 001.444.286 1.326 1.326 0 00.718-.713c.066-.16.1-.33.1-.504V3.14zM23.648 3.14h-2.65v7.37h2.65V3.14zM28.422 5.51a1.332 1.332 0 011.149.657l2.293-1.319a3.967 3.967 0 00-1.921-1.673 4 4 0 00-2.55-.166 3.977 3.977 0 00-2.125 1.41 3.932 3.932 0 000 4.808 3.977 3.977 0 002.125 1.41 4 4 0 002.55-.165 3.966 3.966 0 001.921-1.674l-2.293-1.314a1.321 1.321 0 01-1.147.657 1.332 1.332 0 01-1.147-.658 1.309 1.309 0 01.485-1.797 1.33 1.33 0 01.661-.176M41.01 10.51l-3.978-3.686 3.71-3.684h-3.44l-2.175 2.162V.046h-2.65v10.465h2.65V8.35l2.175 2.16h3.709z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.866 9.7a2.869 2.869 0 011.176-2.316 2.913 2.913 0 012.574-.44 5.354 5.354 0 00-.134-3.502A5.397 5.397 0 008.208.764a5.454 5.454 0 00-6.62.815A5.358 5.358 0 00.77 8.156a5.414 5.414 0 002.697 2.257 5.458 5.458 0 003.525.132 2.877 2.877 0 01-.127-.845zM2.79 5.385c0-.518.154-1.023.443-1.453.29-.43.7-.765 1.181-.963a2.648 2.648 0 012.868.566 2.608 2.608 0 01.57 2.85c-.199.477-.536.885-.97 1.172a2.644 2.644 0 01-3.321-.325 2.604 2.604 0 01-.77-1.847z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "quick_svg__clip0_9804_9671"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h41v12H0z"
  })))));
}
export default SvgQuick;